import React from "react";
const ReactRouterDomLink = require("react-router-dom").Link;
import styled from "styled-components";
import cx from "classnames";

const StlLink = styled.a`
  padding: 0 23px;
  height: 38px;
  display: flex;
  align-items: center;
  white-space: nowrap;
  justify-content: center;
`;

const CustomLink = ({
  url, // external
  to = "/", // internal
  children,
  className,
  onClick,
  color,
  ariaLabel,
  dataStore,
  target,
}) => {
  const buttonColor = () => {
    if (color === "primary") {
      return "sunny-button";
    }
    if (color === "secondary") {
      return "white-button";
    } else {
      return "sunny-button";
    }
  };

  {
    if (url) {
      return (
        <StlLink
          color={color}
          href={url}
          onClick={onClick}
          className={cx(className, "link", buttonColor())}
          children={children}
          aria-label={ariaLabel}
          data-store={dataStore}
          target={target}
        />
      );
    }

    return (
      <ReactRouterDomLink to={to} onClick={onClick} className={className}>
        {children}
      </ReactRouterDomLink>
    );
  }
};

export default CustomLink;
